export default {
  en: {
    'pages.tax-codes.heading': 'How do you want to set up your tax codes?',
    'pages.tax-codes.option-one.heading': 'Wizard',
    'pages.tax-codes.option-one.description':
      'We will ask you a set of questions to help you map your tax codes.',
    'pages.tax-codes.option-two.heading': 'Manual',
    'pages.tax-codes.option-two.description':
      'If you understand your tax codes and want to map them manually.',
    'pages.tax-codes.option-three.heading': 'Copy from other',
    'pages.tax-codes.option-three.description':
      'If you have similar tax codes for other countries that you have already set up.',
    'pages.tax-codes.list.description':
      'We need to know what you call your transactions so that we can ensure compliance when generating your draft ' +
      'return.',
    'pages.tax-codes.list.heading': 'Tax Codes',
    'pages.tax-codes.list.notice.heading':
      'Do you have similar tax codes for all your registrations?',
    'pages.tax-codes.list.notice.description':
      'Mapping your tax code can take a while. ' +
      'If you finish mapping your codes for one of your registration you will ' +
      'then have to option to copy the codes to other registrations or entities.',
    'pages.tax-codes.mapping-wizard.heading': 'Mapping Wizard',
    'pages.tax-codes.mapping-wizard.entity': 'Entity',
    'pages.tax-codes.mapping-wizard.reduced-rates.heading':
      'Please mark which VAT rates apply to you on the transactions below',
    'pages.tax-codes.mapping-wizard.reduced-rates.unavailable': 'Unavailable',
    'pages.tax-codes.mapping-wizard.reduced-rates.not-selected':
      "Don't have any applicable tax codes?",
    'pages.tax-codes.mapping-wizard.reduced-rates.unavailable.description':
      'No rates currently available for your region, please contact your administrator',
    'pages.tax-codes.mapping-wizard.reduced-rates.not-selected.description':
      "It appears that you didn't answer 'Yes' to any of the previous questions, if you do have tax codes please restart this section to map them out.",
    'pages.tax-codes.copy.from.select-registrations': 'Select Registrations',
    'pages.tax-codes.copy.to.select-registrations': 'Select Registrations',
    'pages.tax-codes.copy.from.choose-tax-codes': 'Choose tax codes',
    'pages.tax-codes.copy.from.heading': 'Apply Tax Codes from other registrations',
    'pages.tax-codes.apply.to.heading': 'Apply Tax Codes to other registrations',
    'pages.tax-codes.copy.from.sub-heading': 'Speed things up if you have similar tax codes',
    'pages.tax-codes.apply-to.description': 'Speed things up if you have similar tax codes',
    'pages.tax-codes.results.info-helper': 'Click to view more info',
    'pages.manual.tax-codes.duplicates.error':
      'We have detected duplicate tax codes (highlighted in red below), please ensure all tax codes are unique and try again.',
    'pages.tax-codes.notifications.saved': 'Saved successfully.',
    'pages.tax-codes.search.place-holder': 'Search entities',
  },
};
